module.exports = __webpack_public_path__ + "img/surf.3dbc3fa1.svg";